import Project7_Background from "../Images/Project7/Background.png";
import Project7_Thumbnail from "../Images/Project7/Thumbnail.jpg";

import Project7_Cover_Image from "../Images/Project7/Cover.png";

import Project7_Gallery_Image1 from "../Images/Project7/Gallery_Image1.png";
import Project7_Gallery_Image2 from "../Images/Project7/Gallery_Image2.png";
import Project7_Gallery_Image3 from "../Images/Project7/Gallery_Image3.png";
import Project7_Gallery_Image4 from "../Images/Project7/Gallery_Image4.JPG";
import Project7_Gallery_Image5 from "../Images/Project7/Gallery_Image5.png";
import Project7_Gallery_Image6 from "../Images/Project7/Gallery_Image6.png";
import Project7_Gallery_Image7 from "../Images/Project7/Gallery_Image7.png";
import Project7_Gallery_Image8 from "../Images/Project7/Gallery_Image8.jpeg";
import Project7_Gallery_Image9 from "../Images/Project7/Gallery_Image9.jpg";
import Project7_Gallery_Image10 from "../Images/Project7/Gallery_Image10.png";
import Project7_Gallery_Image11 from "../Images/Project7/Gallery_Image11.png";
import Project7_Gallery_Image12 from "../Images/Project7/Gallery_Image12.png";
import Project7_Gallery_Image13 from "../Images/Project7/Gallery_Image13.png";
import Project7_Gallery_Image14 from "../Images/Project7/Gallery_Image14.png";
import Project7_Gallery_Image15 from "../Images/Project7/Gallery_Image15.png";
import Project7_Gallery_Image16 from "../Images/Project7/Gallery_Image16.png";
import Project7_Gallery_Image17 from "../Images/Project7/Gallery_Image17.png";

export const Project7 = {
  id: "tail",
  title: "Robotic Tail Exoskeleton",
  content: (
    <p>
      This research introduces a bio-inspired robotic tail exoskeleton designed
      to assist human balance, drawing inspiration from animals like cats and
      kangaroos.
      <br />
      <br />
      The device aims to address the significant issue of falls, especially
      among the elderly.
      <br />
      <br />
      Its key features include a 3-degree-of-freedom mechanism, retractability
      for portability, low-cost materials, and adjustability for various body
      types.
      <br />
      <br />
      Keywords: Bio-inspired tail exoskeleton, robotic tail, balance assistive
      device, fall prevention, flexible robotic tail, 3DOF manipulator,
      biomimetic mechanical design, posture sensor, collapsible exoskeleton,
      biomimicry.
      <br />
      <br />
    </p>
  ),
  thumbnail: Project7_Thumbnail,
  backgroundImage: Project7_Background,
  tags: [
    "#Robotic",
    "#Exoskeleton",
    "#Wearable",
    "#Retractable",
    "#BalanceAssisted",
    "#ROS2",
    "#NonLinearIKSolver",
    "#MicroROS",
  ],
  detail_of_the_project_url:
    "https://drive.google.com/open?id=1u3ofxMrdVFWN7lLvQk_F6UgWXj5DjXbM&usp=drive_fs",
  details_BTN_text: <div>Details (ISEF)</div>,
  explaination: "A bio-inspired robotic tail exoskeleton for human balance assistance",
  time: "2025",
  about_this_Project: (
    <div>
      <h1>About this Project</h1>
      <p>
        This is a 3rd-place project at the Engineering Statics and Dynamic Categories (ETSD) in 2025 Regeneron ISEF (International Science and Engineering Fair)
      </p>
      Link to Poster: <a href="https://drive.google.com/open?id=1su8B0twBbnAECYvczHjvOSJBq0NsKEXJ&usp=drive_fs" target="_blank" rel="noopener noreferrer">Click here for poster</a>
      <br />
      Link to Video: <a href="https://youtu.be/baPv6LGj2Nc" target="_blank" rel="noopener noreferrer">Click here for video</a>
      <br />
      Link to Report: <a href="https://drive.google.com/open?id=1u3ofxMrdVFWN7lLvQk_F6UgWXj5DjXbM" target="_blank" rel="noopener noreferrer">Click here for report</a>
      <br />
      Link to ISEF: <a href="https://isef.net/project/etsd013t-a-robotic-tail-exoskeleton" target="_blank" rel="noopener noreferrer">Click here for ISEF showcase</a>
      <p>
        This research introduces a bio-inspired robotic tail exoskeleton
        designed to assist human balance, drawing inspiration from animals like
        cats and kangaroos.
        <br />
        <br />
        The device aims to address the significant issue of falls, especially
        among the elderly.
        <br />
        <br />
        Its key features include a 3-degree-of-freedom mechanism,
        retractability for portability, low-cost materials, and adjustability
        for various body types.
        <br />
        <br />
        This project combines biomimetic design principles with practical
        engineering to create a flexible, wearable balance assistive device.
        <br />
        <br />
        Keywords: Bio-inspired tail exoskeleton, robotic tail, balance
        assistive device, fall prevention, flexible robotic tail, 3DOF
        manipulator, biomimetic mechanical design, posture sensor, collapsible
        exoskeleton, biomimicry.
        <br />
        <br />
      </p>
      <h1>Videos</h1>
      <br/>
      <br/>
      <iframe width="80%" height="792" src="https://www.youtube.com/embed/ULw-qZU1yBI" title="Tail Tests" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      <h1>Some Images</h1>
      <br/>
      <br/>
      <img width="80%" src={Project7_Gallery_Image16} alt="Image 16" />
      <br />
      <img width="80%" src={Project7_Gallery_Image3} alt="Image 3" />
    </div>
  ),
  Cover: Project7_Cover_Image,
  Abstract_Images: [],
  Gallery_Images: [
    Project7_Gallery_Image1,
    Project7_Gallery_Image2,
    
    Project7_Gallery_Image4,
    Project7_Gallery_Image5,
    Project7_Gallery_Image6,
    Project7_Gallery_Image7,
    Project7_Gallery_Image8,
    Project7_Gallery_Image9,
    Project7_Gallery_Image10,
    Project7_Gallery_Image11,
    Project7_Gallery_Image12,
    Project7_Gallery_Image13,
    Project7_Gallery_Image14,
    Project7_Gallery_Image15,
    Project7_Gallery_Image17,
    Project7_Cover_Image,
    Project7_Background,
    Project7_Thumbnail,
  ],
};
